import React, { useContext } from "react"
import { Context } from "../../components/store/UserProvider"

const useVideoEnd = strapi_video_id => {
  const ctx = useContext(Context)
  let watchedArray

  const watchedVideo = () => {
    if (!ctx.watchedVids) {
      watchedArray = [strapi_video_id]
    } else {
      const checkIfWatched = ctx.watchedVids.includes(strapi_video_id)

      if (checkIfWatched) {
        watchedArray = null
      } else {
        watchedArray = [...ctx.watchedVids, strapi_video_id]
      }
    }

    if (watchedArray) {
      sendData(watchedArray)
    }
  }

  const sendData = watchedArray => {
    // const myHeaders = new Headers()
    // myHeaders.append("Authorization", `Bearer ${ctx.userGlobalState.token}`)

    // const formdata = new FormData()
    // formdata.append("watched_videos", `${JSON.stringify(watchedArray)}`)

    // const requestOptions = {
    //   method: "PUT",
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: "follow",
    // }

    // fetch(
    //   `https://montessori-back.herokuapp.com/api/users/${ctx.userGlobalState.userId}`,
    //   requestOptions
    // )
    //   .then(response => response.text())
    //   .then(result => console.log(result))
    //   .catch(error => console.log("error", error))
    //   .finally(() => {
    //     ctx.getWatchedVids()
    //   })

    const myHeaders = new Headers()
    myHeaders.append("Authorization", `Bearer ${ctx.userGlobalState.token}`)

    const formdata = new FormData()
    formdata.append("userId", `${ctx.userGlobalState.userId}`)
    formdata.append("watched_videos", `${JSON.stringify(watchedArray)}`)
    formdata.append("mode", `ADD`)
    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    }

    fetch(`https://montessori-back.herokuapp.com/api/watched`, requestOptions)
      .then(response => response.text())
      .then(result => console.log(result))
      .catch(error => console.log("error", error))
      .finally(() => {
        ctx.getWatchedVids()
      })
  }

  return {
    watchedVideo,
  }
}

export default useVideoEnd
